<template>
  <div class="outer-box restore-locations">
    <h4>Restore Locations</h4>
    <div v-if="deletedLocationsFromAgency.length > 0" class="inner-box" style="text-align: left; width: 600px;">
        <button
          class="btn btn-danger mb-4"
          @click="deletedLocationsFromAgency = []"
        >Clear / Get another Agency</button>
        <input class="hl_input--wrap" type="text" v-model="locationNameSearch" placeholder="Search Location by name">
      <div class="location" v-for="location in filteredDeletedLocations" :key="location.id">
        <div class="location-info">
          <h5 style="margin-bottom: 1px;">{{ location.name }}</h5>
          <span>{{ location.id }}</span>
          <span v-if="location.address">{{ location.address }}</span>
          <span v-if="location.email">{{ location.email }}</span>
        </div>
        <button
          :disabled="restoringLocation.includes(location.id)"
          class="btn btn-primary"
          @click="restoreLocation(location)"
        >
          <moon-loader
            v-if="restoringLocation.includes(location.id)"
            :loading="true"
            size="21px"
            color="#fafafa"
          />
          <span v-else>Restore</span>
        </button>
      </div>
    </div>
    <div v-else class="inner-box" style="text-align: left; width: 600px;">
      <input
        class="hl_input--wrap my-1"
        type="text"
        placeholder="Company Id or Relationship Number"
        v-model="companyIdOrRelationshipNumber"
      />
      <input
        class="hl_input--wrap my-1"
        type="text"
        placeholder="Location Name (enter exact name)"
        v-model="locationName"
      />
      <button class="btn btn-primary mt-4" @click="getDeletedLocations">
        <moon-loader v-if="gettingLocations" :loading="true" size="21px" color="#fafafa" />
        <span v-else>Get Deleted Locations</span>
      </button>
    </div>

    <multiple-users-modal v-if="showModal" :multiple-users-data="multipleUsersData" @submit="modalSubmit" @close="closeModal"/>
  </div>
</template>

<script>
import { SpmAppengineService, LocationsService } from '@/services';
import MultipleUsersModal from './../MultipleUsersModal.vue'

export default {
  components: { MultipleUsersModal },
  data() {
    return {
      agencyEmail: null,
      companyIdOrRelationshipNumber: null,
      locationName: '',
      newAgencyEmail: null,
      deletedLocationsFromAgency: [],
      restoringLocation: [],
      gettingLocations: false,
      locationNameSearch: '',
      showModal: false,
      multipleUsersData: {}
    };
  },
  computed: {
    filteredDeletedLocations() {
      return this.deletedLocationsFromAgency.filter(location => location.name.includes(this.locationNameSearch))
    }
  },
  methods: {
    async restoreLocation(location) {
      const locationId = location.id
      if (confirm(`Are you certain that ${location.name} needs to be restored? It will take a few minutes for changes to take effect.`)) {
        this.restoringLocation.push(locationId);
        try {
          const { data } = await LocationsService.restoreLocation(locationId)
          this.deletedLocationsFromAgency = this.deletedLocationsFromAgency.filter(location => location.id !== locationId)
        } catch (err) {
          this.$handleError(err)
        } finally {
          let index = this.restoringLocation.indexOf(locationId)
          this.restoringLocation.splice(index, 1)
        }
      }
    },
    async checkForMultipleUsers() {
      let response = await SpmAppengineService.checkMultipleUsers(this.agencyEmail)
      if(Array.isArray(response.data) && response.data.length > 0) {
        this.multipleUsersData = { data: response.data }
        this.showModal = true
      } else {
        this.getDeletedLocations()
      }
    },
    async getDeletedLocations() {
      this.gettingLocations = true;
      try {
        const response = await SpmAppengineService.getDeletedLocations(this.companyIdOrRelationshipNumber, this.locationName)
        if(!response.data.deletedLocations){
          throw new Error('No deleted locations found')
        }
        this.deletedLocationsFromAgency = response.data.deletedLocations.map(doc => { return {...doc._data, id: doc._id } });
      } catch (err) {
          this.$handleError(err)
      } finally {
        this.gettingLocations = false;
      }
    },
    modalSubmit({ data }) {
      this.getDeletedLocations(companyIdOrRelationshipNumber, locationName)
    },
    closeModal() {
      this.showModal = false
    },
  }
}
</script>

<style>
.location {
  border-bottom: 0.5px solid #ddd;
  padding: 16px;
  display: flex;
  justify-content: space-between;
}
.location:last-child {
  border-bottom: none;
}
.location-info {
  font-size: 10pt;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  margin-bottom: 8px;
}
.restore-locations {
  min-width: 40vw;
}
</style>
